/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Voice_Start_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not start a conversation for voice. Please try again." |
*
* @param {Uno_Voice_Start_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_voice_start_error = /** @type {((inputs?: Uno_Voice_Start_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Voice_Start_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für die Spracheingabe konnte keine Unterhaltung gestartet werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Could not start a conversation for voice. Please try again.")
});